export interface FitnessYourWayProps {
  headerKey: string;
  descriptionKey: string;
  buttonTextKey?: string;
  handleClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

export const commercialFitnessYourWayProps: FitnessYourWayProps = {
  headerKey: 'fitnessYourWay.heading',
  descriptionKey: 'fitnessYourWay.description',
  buttonTextKey: 'fitnessYourWay.cta',
};

export const governmentFitnessYourWayProps: FitnessYourWayProps = {
  headerKey: 'fitnessYourWay.heading',
  descriptionKey: 'fitnessYourWay.description',
  buttonTextKey: 'fitnessYourWay.cta',
};
